import { useState, useEffect } from "react";
import { getInitPage, parseSearch } from "../../utils/platform";
import { useLocation, useNavigate } from "react-router-dom"; // 替换 useHistory 为 useNavigate

const usePage = function () {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const [initPage, setInitPage] = useState(getInitPage(parseSearch(search)));
  const [nextPage, setNextPage] = useState(initPage);

  useEffect(() => {
    const url = new URLSearchParams(search);
    const page = Number(url.get("page"));
    const currentPage = page || 1;
    setInitPage(currentPage);
  }, [search]);

  useEffect(() => {
    if (initPage !== nextPage) {
      const url = new URLSearchParams(search);
      url.set("page", nextPage);
      navigate({
        pathname: pathname,
        search: `?${url.toString()}`,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextPage, search, pathname, navigate]);

  return [initPage, setNextPage];
};

export default usePage;
